import { Card, Flex, Spin, Typography } from 'antd'
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { useAuth } from '@hooks/useAuth'

import { LoginForm } from './LoginForm'

export const LoginPage: React.FC = () => {
    const { user, isReady } = useAuth()
    const navigate = useNavigate()

    useEffect(() => {
        if (user && isReady) {
            navigate('/')
        }
    }, [user, isReady])

    return (
        <Flex justify="center" align="center" style={{ minHeight: '60vh' }}>
            {!isReady ? (
                <Spin size="large" />
            ) : (
                <Card style={{ width: '100%', maxWidth: 400 }} styles={{ body: { padding: 32 } }}>
                    <Flex vertical gap="large">
                        <Flex vertical align="center" gap="xsmall">
                            <img src="/admin.png" alt="" width={48} height={48} />
                            <Typography.Title level={3} style={{ margin: 0 }}>
                                Welcome back
                            </Typography.Title>
                            <Typography.Text type="secondary">Sign in to Pomegranate Admin</Typography.Text>
                        </Flex>
                        <LoginForm />
                    </Flex>
                </Card>
            )}
        </Flex>
    )
}
